module.exports = __webpack_public_path__ + "img/back-card.0c4e88d3.png";